var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.998 160.705L132.309 249.235C131.615 250.255 130.126 250.255 129.433 249.235L76.743 160.705H185.019H184.998Z",
    fill: "#104B39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2235 66.2801C85.4939 88.2699 74.6826 116.196 67.3799 148.854H94.0613C105.036 130.903 117.928 114.564 130.86 100.305C118.825 87.0255 106.79 75.5615 96.2235 66.2801Z",
    fill: "#00AC69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.86 100.305C142.875 87.0456 154.931 75.5612 165.477 66.3002C165.477 66.2594 165.436 66.239 165.436 66.1982C150.259 35.1311 130.86 10 130.86 10C130.86 10 111.4 35.1923 96.2233 66.3002C106.769 75.5612 118.825 87.0456 130.86 100.325V100.305Z",
    fill: "#B8E7D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2237 66.2794C78.3545 50.5316 65.279 41.5358 65.279 41.5358C24.4817 98.244 64.0959 145.161 67.38 148.853C74.6827 116.195 85.5144 88.2691 96.2237 66.2794Z",
    fill: "#76CFAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.422 41.5365C196.422 41.5365 183.346 50.5323 165.477 66.2801C165.477 66.2393 165.436 66.2189 165.416 66.1781C165.416 66.2189 165.456 66.2393 165.456 66.2801C165.497 66.2597 165.538 66.2189 165.558 66.1781C165.518 66.1985 165.497 66.2393 165.456 66.2801C176.186 88.2698 187.038 116.175 194.341 148.813C197.768 144.917 237.117 98.1019 196.401 41.5161L196.422 41.5365Z",
    fill: "#76CFAD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0613 148.853H167.66C156.685 130.903 143.793 114.563 130.86 100.305C117.928 114.563 105.036 130.903 94.0613 148.853Z",
    fill: "#104B39"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.86 100.305C143.793 114.564 156.664 130.903 167.659 148.854H194.341C194.341 148.854 194.361 148.833 194.361 148.813C187.058 116.175 176.206 88.2699 165.477 66.2801C154.93 75.5411 142.875 87.0255 130.86 100.285V100.305Z",
    fill: "#00AC69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerLogo);
export default __webpack_public_path__ + "static/media/locker_logo.cb80e32152a76c6d60a2c010259887b4.svg";
export { ForwardRef as ReactComponent };